import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
// import { useAuth } from "../Auth/Auth";
import {apiHeader} from '../../../utils/apiHeader'
import axios from "axios";
import { globalConfig } from "../../../config/config";
// const querystring = require("querystring");
const ManageContentDescriptors = ({ location }) => {
  let parms = new URLSearchParams(location.search);
  const [contentDescriptorTypes, setContentDescriptorTypes] = useState([]);
  const [entitlements, setEntitlements] = useState([]);
  const [message, setMessage] = useState("");
  const {token,userMetadata}=useAuth()
  const history = useHistory();
  const [state, setState] = useState({
    contentDescriptorId: parseInt(parms.get("id")),
    contentId: 0,
    securityContextId: 0,
    contentDescriptorTypeId: 0,
    serverModuleValueCode: 0,
    contentDescriptorName: "",
    contentDescriptorDescription: "",
    contentDescriptorCdata: "",
    contentDescriptorBdata: "",
    createUser: 0,
    createDate: new Date(),
    lastUpdateUser: 0,
    lastUpdateDate: new Date().toISOString(),
  });

  useEffect(() => {
    handleOnLoad();
  }, []);

  function handleSave(event) {
    console.log("handling save 1");

    event.preventDefault();
    console.log("handling save");

    var url = `${globalConfig.apiDatahubUrl}/content-descriptors/${state.contentDescriptorId}`;

    axios
      .patch(url, state, apiHeader(token))
      .then((response) => {
        console.log("response.data");
        console.log(response.status + ":" + response.data.contentDescriptorId);

        if (response.status === 200) {
          setMessage("Success");
          setInterval(() => {
            window.location.reload();
          }, 1000);
        } else {
          setMessage("Failed");
        }
        console.log(message);
        event.preventDefault();
      })
      .catch((err) => {
        console.log("error - " + err);
      });
    console.log("message info - " + message);
  }
  function handleChange(event) {
    console.log(event);
    var target = event.target;
    console.log(target.id + ":" + target.value);
    setState({
      ...state,
      [target.id]: isNaN(target.value)
        ? target.value
        : target.value === ""
        ? ""
        : parseInt(target.value),
    });

    console.log(state);
  }

  const handleOnLoad = () => {
    axios
      .get(
        `${globalConfig.apiDatahubUrl}/content-descriptor-types`,
        apiHeader(token)
      )
      .then((res) => {
        const contentDescriptorTypes = res.data;
        console.log(contentDescriptorTypes);
        setContentDescriptorTypes(contentDescriptorTypes);
      });

    axios
      .get(
        `${globalConfig.systemCodesUrl}/ENTITLEMENTS`,
        apiHeader(token)
      )
      .then((res) => {
        const entitlements = res.data;
        console.log("results", entitlements);
        setEntitlements(entitlements);
      })
      .catch((err) => {
        console.log("here");
        console.log(err);
      });

    console.log("handleOnLoad() - loading id = " + state.contentDescriptorId);
    axios
      .get(
        `${globalConfig.apiDatahubUrl}/content-descriptors/${state.contentDescriptorId}`,
        apiHeader(token)
      )
      .then((res) => {
        const contentType = res.data;
        console.log("contentType");
        console.log(contentType);
        setState(contentType);
        console.log("state");
        console.log(state);
      });
  };
  function onDelete() {
    let deleteID = state.contentDescriptorId;
    axios
      .delete(
        `${globalConfig.apiDatahubUrl}/content-descriptors/` + deleteID,
        apiHeader(token)
      )
      .then((res) => {
        console.log("Delete Response:" + res.data);
        history.goBack();
      })
      .catch((err) => console.log("Err delete:" + err));
  }
  return (
    <form>
      <div className="container-fluid">
      <button
          type="button"
          className="btn btn btn-outline-secondary mt-2 mb-3"
          onClick={() => history.goBack()}
        >
          Go Back
        </button>
        <h4>Manage Content Descriptors</h4>
        <hr />
        <div className="form-group row">
          <label className="ContentTitle col-sm-2" value="Choose Descriptor">
            Choose Descriptor
          </label>
          <select
            onchange="submit()"
            id="content_descriptor_id"
            className="form-control input-xlarge col-sm-8"
            value="#{contentDescriptorForm.currentContentDescriptor.contentDescriptorId}"
            valueChangeListener="#{contentDescriptorForm.get}"
          >
            <option value="#{contentDescriptorForm.contentDescriptorSelectList}" />
          </select>
        </div>
        <div className="form-group row">
          <label className="ContentTitle col-sm-2">Content Object Name</label>
          <input
            id="contentDescriptorName"
            readOnly={true}
            className="form-control input-xlarge col-sm-8"
            value={state.contentId}
            onChange={handleChange}
          />
        </div>
        <div className="form-group row">
          <label className="ContentTitle col-sm-2" value="Descriptor Type">
            Descriptor Type
          </label>
          {/* <SelectListComponent entityName ={"system-code-values"} valueFilterColumnName = {"systemCodeId"} valueFilter = {"234"} displayColumnName ={"systemCodeValueValue"} keyColumnName ={"systemCodeValueId"}
				IdName={"contentDescriptorTypeId"}
				TypeId={state.contentDescriptorTypeId}
				handle={handleDropDown}
		        /> */}
          <select
            id="contentDescriptorTypeId"
            className="form-control input-xlarge col-sm-8"
            value={state.contentDescriptorTypeId}
            onChange={handleChange}
          >
            {/* <option value="#{contentFacadeForm.contentFacadeTypeSelectList}" /> */}
            <option>Click to make selection</option>
            {contentDescriptorTypes.map(
              ({ contentDescriptorTypeDescr, contentDescriptorTypeId }) => (
                <option
                  key={contentDescriptorTypeId}
                  value={contentDescriptorTypeId}
                >
                  {contentDescriptorTypeDescr}
                </option>
              )
            )}
          </select>
        </div>
        <div className="form-group row">
          <label className="ContentTitle col-sm-2" value="Descriptor Object">
            Descriptor Object
          </label>
          <input
            id="contentDescriptorName"
            className="form-control input-xlarge col-sm-8"
            value={state.contentDescriptorName}
            onChange={handleChange}
          />
        </div>
        <div className="form-group row">
          <label
            className="ContentTitle col-sm-2"
            value={state.contentDescriptorDescription}
          >
            Description
          </label>

          <input
            id="contentDescriptorDescription"
            className="form-control input-xlarge col-sm-8"
            value={state.contentDescriptorDescription}
            onChange={handleChange}
          />
        </div>
        <div className="form-group row">
          <label className="ContentTitle col-sm-2" value="Characters">
            Characters
          </label>
          <textarea
            name="content_descriptor_cdata"
            className="form-control input-xlarge col-sm-8"
            cols="60"
            rows="2"
            value=""
          />
        </div>
        <div className="form-group row">
          <label className="ContentTitle col-sm-2" value="Binary Data">
            Binary Data
          </label>
          <input
            it="contentDescriptorBdata"
            value=""
            name="content_descriptor_bdata"
            className="form-control input-xlarge col-sm-8"
            cols="60"
            rows="2"
          />
        </div>
        <div className="form-group row">
          <label className="ContentTitle col-sm-2" value="Server Module">
            Server Module
          </label>
          {/* <SelectListComponent entityName ={"system-code-values"} valueFilterColumnName = {"systemCodeId"} valueFilter = {"222"} displayColumnName ={"systemCodeValueValue"} keyColumnName ={"systemCodeValueId"}
				IdName ={"serverModuleValueCode"}
				TypeId={state.serverModuleValueCode}
				handle={handleDropDown}
				/> */}
          <select
            id="serverModuleValueCode"
            className="form-control input-xlarge col-sm-8"
            value={state.serverModuleValueCode}
            onChange={handleChange}
          >
            <option value={0}>Select Entitlement </option>
            {entitlements.map(
              ({ systemCodeId, systemCodeValueValue, systemCodeValueId }) => (
                <option key={systemCodeValueId} value={systemCodeValueId}>
                  {systemCodeValueValue}{" "}
                </option>
              )
            )}
          </select>
        </div>
        <hr />
        <div className="form-group row">
          <label className="ContentTitle col-sm-2" value="Last Updated By">
            Last Updated By
          </label>
          <input
            className="form-control input-xlarge col-sm-8"
            value={state.lastUpdateUser}
          />
        </div>
        <div className="form-group row">
          <label className="ContentTitle col-sm-2" value="Last Updated On">
            Last Updated On
          </label>
          <input
            className="form-control input-xlarge col-sm-8"
            type="datetime-local"
            value={state.lastUpdateDate.slice(0, 16)}
          ></input>
        </div>
        <hr />
        <div columns="3">
        <button className="btn btn-danger" value="Delete" onClick={onDelete}>
            {" "}
            Delete
          </button>
          &nbsp;
          <button className="btn btn-success" value="Save" onClick={handleSave}>
            {" "}
            Save
          </button>
          &nbsp;

        </div>
      </div>
    </form>
  );
};

export default ManageContentDescriptors;
